/**
 * Get the GeoJSON data for the blocks from the server.
 *
 * @package
 */

/**
 * WordPress dependencies
 */
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

/**
 * The GeoJSON type
 *
 * @typedef		{Object}		GeoJSON		The GeoJSON data
 * @property {Feature[]} features   The GeoJSON features
 * @property {Geometry}  geometry   The feature geometry
 * @property {FeatProps} properties
 *                                  /
                                    /**
 *                                  The GeoJSON feature type
 * @typedef		{Object}		Feature		The GeoJSON feature
 * @property {string}    type       The feature type
 * @property {number}    id         The feature ID
 */
/**
 * The GeoJSON geometry type
 * @typedef		{Object}		Geometry	The GeoJSON geometry
 * @property {number[]} coordinates The feature coordinates
 * @property {string}   type        The feature geometry type
 */
/**
 * The GeoJSON feature properties type
 * @typedef		{Object}		FeatProps	The GeoJSON feature properties
 * @property {string} title The feature title
 */
interface GeoJson {
	features: {
		type: string;
		id: number;
		geometry: {
			coordinates: number[];
			type: string;
		};
		properties: {
			title: string;
		};
	}[];
}

/**
 * Get GeoJSON from the API
 *
 * @param {string} page  The page ID
 * @param {string} block The block ID
 * @return	{Promise<GeoJson>}	The GeoJSON data
 */
const getGeoJson = ( page: string, block: string ) => {
	/**
	 * The API URL path
	 *
	 * @param {string} path The API path
	 */
	const path = addQueryArgs( '/stockistmap/v1/geojson', {
		page,
		block,
	} );

	return apiFetch< GeoJson >( { path } );
};

export default getGeoJson;
